export default "__VITE_ASSET__D3l$Y4ur__"